<template>
  <div>
    <div class="grid">
      <div v-for="(item,index) in list" :key="index" @click="clickItem(item)" class="item">
        <el-image style="width: 100%;border-radius: 10px;" mode="widthFix"
          :src="url+item.busBook.coverImageUrl" />
        <div class="item_jd">
          读至{{item.readPage/item.busBook.totalPage * 100}}%</div>
        <div class="item_bottom">
          <span style="color: white;margin-top: 5px;">{{item.busBook.bookName}}</span>
          <span style="color: white;margin-top: 5px;font-size: 13px;">{{item.busBook.bookVersion}}</span>
          <div class="flex-row" style="margin-top: 5px;">
            <!-- <img style="width: 20px;margin-left: 0px;cursor: pointer;" src="@/assets/center/ic1.png" /> -->
            <!-- <img style="width: 18px;margin-left: 10px;cursor: pointer;" src="@/assets/center/ic2.png" /> -->
            <img style="width: 15px;margin-left: 10px;cursor: pointer;" @click="deleteFavor(item)"
              src="@/assets/center/ic3.png" />
          </div>
        </div>
      </div>
    </div>
    <div class="flex-row justify-center">
      <el-pagination background layout="prev, pager, next" @current-change="currentChange" :page-size="scParam.pageSize"
        :total="scToTal">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import {
    favorList,
    deleteFavor,
    readList
  } from '@/api/favor'
  export default {
    data() {
      return {
        url: 'http://47.106.169.20:8084/api-biz',
        scParam: {
          pageNum: 1,
          pageSize: 20,
        },
        scToTal: 0,
        list: []
      };
    },
    mounted() {
      this.queryFavorList()
    },
    methods: {
      clickItem(item) {
        this.$router.push({
          path: '/view',
          query: {
            page: item.readPage,
            id: item.bookId
          }
        })
      },
      deleteFavor(item) {
        deleteFavor(item.favorId).then((res) => {
          if (res.code == 200) {
            this.$message.success('已取消收藏')
            this.queryFavorList()
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      queryFavorList() {
        favorList(this.scParam).then((res) => {
          console.log(res)
          this.list = res.rows
          this.scToTal = res.total
        })
      },

      currentChange(e) {
        this.scParam.pageNum = e
        this.queryFavorList()
      }
    }
  }
</script>

<style scoped>
  .grid {
    display: grid;
    grid-template-columns: repeat(3, calc((100% - 50px) / 3));
    grid-column-gap: 25px;
    grid-row-gap: 30px;
    padding: 25px;
    overflow-y: auto;
    height: calc(22.5rem - 55px - 25px - 50px);
  }

  .item {
    overflow: hidden;
    cursor: pointer;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 300px;
    position: relative;
  }

  .item_bottom {
    background: rgba(0, 0, 0, 0.49);
    color: white;
    position: absolute;
    left: 0px;
    bottom: 0px;
    font-size: 16px;
    padding: 5px 10px 10px 10px;
    display: flex;
    flex-direction: column;
    width: 100%;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  .item_jd {
    background-color: rgba(48, 42, 26, 1.0);
    color: white;
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 14px;
    padding: 5px 10px 5px 10px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/com/mysc/index.vue